import React, {Suspense} from 'react';
import DashboardLeft from '../../shared/DashboardLeft';
import Header from '../../shared/Header';
import Footer from '../../shared/Footer';
import FormProduct from '../form/FormProduct';
import Translator from '../../translations/Translator';
import Line from '../../shared/Line';

function PageProductsForm() {
    document.title = 'Product - zizier';
    return (
        <Suspense
            fallback={
                <p>
                    <Translator value="i18n.loading" />
                </p>
            }
        >
            <div className="row">
                <Header />
                <DashboardLeft />
                <div className="col-md-9">
                    <h5>
                        <Translator value="i18n.product.form" />
                    </h5>
                    <Line />
                    <FormProduct />
                </div>
                <Footer />
            </div>
        </Suspense>
    );
}

export default PageProductsForm;
